import {createSlice, PayloadAction} from '@reduxjs/toolkit';
import {logoutAction} from '../rootAction';

interface ModalDropDownSelectedItem {
  id: string;
  name: string;
  code?: string;
  alphaCode?: string;
  domainCountryCode?: string;
}

interface InvoiceModalState {
  modalIsOpen: boolean;
  modalDropDownSelectedItem: ModalDropDownSelectedItem;
  reportsNavPath: string;
}

const initialState: InvoiceModalState = {
  modalIsOpen: false,
  modalDropDownSelectedItem: {id: '', name: '', code: ''},
  reportsNavPath: '',
};

const invoiceModalSlice = createSlice({
  name: 'invoiceModal',
  initialState,
  reducers: {
    setModalStatus: (state, action: PayloadAction<boolean>) => {
      state.modalIsOpen = action.payload;
    },
    setModalDropDownSelectedItem: (
      state,
      action: PayloadAction<ModalDropDownSelectedItem>
    ) => {
      state.modalDropDownSelectedItem = action.payload;
    },
    setReportNavPath: (state, action: PayloadAction<string>) => {
      state.reportsNavPath = action.payload;
    },
  },
  extraReducers: (builder) => {
    builder.addCase(logoutAction, () => {
      return initialState;
    });
  },
});

export const {setModalStatus, setModalDropDownSelectedItem, setReportNavPath} =
  invoiceModalSlice.actions;
export default invoiceModalSlice.reducer;
